import { render } from "./invertorInstitution.vue?vue&type=template&id=38b172b8&scoped=true"
import script from "./invertorInstitution.vue?vue&type=script&lang=js"
export * from "./invertorInstitution.vue?vue&type=script&lang=js"

import "./invertorInstitution.vue?vue&type=style&index=0&id=38b172b8&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b172b8"]])

export default __exports__